<template>
  <v-container grid-list-md fluid>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card class="px-3">
          <v-card-title primary-title class="title">Save Payment</v-card-title>
          <v-card-text>
            <v-layout row wrap align-center>
              <v-flex xs12  mb-2>
                  <label class="subheading grey--text" for="patient">Patient:</label>
                  <span class="mx-2 subheading">{{payment.patient_name}}</span>
                </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Discount" v-model.number="payment.discount"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="display-1 text-xs-center">
                <h5>Total:</h5>
                <p>{{payment.amount - payment.discount}} AFN</p>
              </v-flex>

              <v-flex xs12 mt-2>
                <p>
                  * Please make sure to have
                  <strong>RECEIVED</strong> the total amount.
                </p>
              </v-flex>

              <v-flex xs12 class="text-xs-right">
                <v-btn flat @click="dialog = false">Close</v-btn>
                <v-btn
                  class="mx-0"
                  :loading="saving" 
                  color="primary"
                  @click="savePayment"
                >Have Recieved</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="section-title di-flex align-center justify-space-between">
          <div class>Payment Queue</div> 

          <div style="width: 50%;">
            <v-text-field 
              prepend-inner-icon="mdi-magnify"
              v-model="paymentQueue_search"
              label="Search"
              hide-details
              single-line
              outline
              class="rounded"
            ></v-text-field>
          </div>
          </div>

        <v-data-table
          :headers="headers"
          :items="paymentQueue"
          disable-initial-sort
          :search="paymentQueue_search" 
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{item}">
            <tr>
              <td>{{ item.patient_name || 'Pharmacy Sale' }}</td>
              <td>{{ item.type | type }}</td>
              <td>{{ item.amount | currency('AFN') }}</td>
              <td>
                <v-tooltip top>
                  <v-icon slot="activator" color="primary" @click="preparePayment(item)">mdi-check</v-icon>
                  <span>Save Payment</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>


      <!-- history -->
      <v-flex xs12 mt-4>
        <div class="section-title di-flex align-center justify-space-between">
          <div class>History</div>
          <div style="width: 50%;">
            <v-text-field
              v-debounce:500ms="getHistory"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
              outline
              class="rounded"
            ></v-text-field>
          </div>
        </div>
        <v-data-table
          :total-items="history.meta.total"
          :pagination.sync="pagination"
          :headers="headers2"
          :items="history.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{item}">
            <tr>
              <td>{{ item.patient ? item.patient.name : 'Pharmacy Sale' }}</td>
              <td>{{ item.payable_type | type }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.discount }}</td>
              <td>{{ item.date | moment('YYYY-MM-DD h:mm:ss A') }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      paymentQueue: [],
      headers: [
        { text: "Patient Name", value: "patient_name" },
        { text: "Type", value: "type" },
        { text: "Amount(AFN)", value: "amount" },
        { text: "", value: "patient_name", sortable: false }
      ],
      headers2: [
        { text: "Patient Name", value: "patient.name", sortable: false },
        { text: "Type", value: "type" },
        { text: "Amount(AFN)", value: "amount" },
        { text: "Discount(AFN)", value: "discount" },
        { text: "Date", value: "date" }
      ],
      history: {
        data: [],
        meta: {},
        links: {}
      },
      pagination: {
        descending: true
      },
      search: "",
      paymentQueue_search:"",
      payment: {},
      dialog: false,
      saving: false
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getHistory();
      }
    }
  },
  methods: {
    preparePayment(item) {
      this.payment = { ...item, discount: 0 };
      this.dialog = true;
    },
    getPaymentsList() {
      this.axios.get("/api/reception_payment").then(resp => {
        this.paymentQueue = resp.data;
      });
    },
    getHistory() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/reception_payment_history?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;

      this.getDataFromApi(query);
    },

    async getDataFromApi(path) {
      const { data } = await this.axios.get(path);
      if (data) this.history = data;
    },

    savePayment() {
      this.saving = true;
      let payment = { ...this.payment };
      payment.amount = payment.amount - payment.discount;

      this.axios
        .post(`/api/reception_payment`, payment)
        .then(resp => {
          this.getPaymentsList();
          this.getHistory();
          this.dialog = false;
          this.saving = false;
        })
        .catch(err => {
          this.saving = false;
          this.dialog = false;
        });

      console.log(payment);

      // this.$modal.show({
      //   title: "Save Payment",
      //   message: `Please make sure to have RECEIVED: <strong> ${payment} AFN </strong>`,
      //   confirmBtn: {
      //     color: "primary",
      //     text: "Received"
      //   },
      //   onConfirm: async () => {
      //     await this.axios.post(`/api/reception_payment`, payment);
      //     this.getPaymentsList();
      //     this.getHistory();
      //   }
      // });
    }
  },
  filters: {
    type: function(value) {
      const map = {
        patient_test: "Lab Test Fee",
        patient_procedure: "Procedure Fee",
        prescriptions: "Prescription Total",
        appointments: "Appointment Fee"
      };

      return map[value];
    }
  },
  mounted() {
    this.getPaymentsList();
  }
};
</script>